export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pdf.worker.f81da2ba.worker.js");
}
